export default __webpack_public_path__ + "static/illustration-content-desc.url-f1b947332a673be9e6a0dbc3527bc5e6.svg";